/**
 * Component to handle profile bulk upload
 */
import * as React from 'react';
import { Card, Breadcrumb, Steps } from 'antd';
import service from '../../service/apolloclient.service';
import '../../css/ProfileBulkUpload.scss';
import strings from '../../eyeguide-localization/profile/strings.profile.bulkupload';
import UploadContentOne from './uploadprofilesteps/UploadProfileContentOne';
import UploadContentTwo from './uploadprofilesteps/UploadProfileContentTwo';
import UploadContentThree from './uploadprofilesteps/UploadProfileContentThree';
import UploadContentFour from './uploadprofilesteps/UploadProfileContentFour';
import UploadContentFive from './uploadprofilesteps/UploadProfileContentFive';
import Util from '../common/utils';
import { IcommonProps } from '../common/props';
// import Comparator from '../common/comparer';
import Constants from '../common/constants';

const Step = Steps.Step;
const NODATAMSG = 'Not Specified';
const INVALIDGENDERMSG = 'Not Acceptable Gender Value';
const INVALIDEMAILMSG = 'Invalid Email Format';
const INVALIDPHONEMSG = 'Invalid Phone Format';
const INVALIDSPROT = 'Invalid Sport';
const INVALIDLEVEL = 'Invalid Level';

interface IProfileBulkUploadProps extends IcommonProps {
    profiles: Array<any>;
    filterObj: any;
    match: any;
    loctaion: any;
}

interface IIProfileBulkUploadState {
    currentProfiles: Array<any>;
    rosterName: string;
    columns: Array<any>;
    columnData: Array<any>;
    csvRows: Array<any>;
    loading: boolean;
    isHeader: boolean;
    pagination: any;
    isError: boolean;
    showInfo: boolean;
    btnDisable: boolean;
    clearBtnDisable: boolean;
    current: number;
    updateCount: number;
    uploadCount: number;
    FirstNameCol: string;
    MiddleNameCol: string;
    LastNameCol: string;
    IDCol: string;
    DOBCol: string;
    GenderCol: string;
    SportCol: string;
    LevelCol: string;
    EmailCol: string;
    PhoneCol: string;
    mappedColumns: Array<any>;
    selectedColumns: any;
    filterObj: any;
    nextStepDisabled: boolean;
    csvFileDesc: string;
    columnHeaders: Array<any>;
    validateGender: any;
    validateEmail: any;
    validatePhone: any;
    getDob: any;
    validateDate: any;
    validateDayOfDate: any;
    maxStepTraversed: number;
}

export default class ProfileBulkUpload extends React.Component<IProfileBulkUploadProps, IIProfileBulkUploadState> {

    steps: any = [];

    constructor(props: IProfileBulkUploadProps) {
        super(props);
        this.state = {
            currentProfiles: [],
            rosterName: '',
            columns: [],
            columnData: [],
            csvRows: [],
            loading: false,
            isHeader: true,
            pagination: {},
            isError: false,
            showInfo: true,
            btnDisable: false,
            clearBtnDisable: false,
            current: 0,
            updateCount: 0,
            uploadCount: 0,
            FirstNameCol: 'Select Column',
            MiddleNameCol: 'Select Column',
            LastNameCol: 'Select Column',
            IDCol: 'Select Column',
            DOBCol: 'Select Column',
            GenderCol: 'Select Column',
            SportCol: 'Select Column',
            LevelCol: 'Select Column',
            EmailCol: 'Select Column',
            PhoneCol: 'Select Column',
            mappedColumns: [],
            selectedColumns: {},
            filterObj: props.filterObj,
            nextStepDisabled: true,
            csvFileDesc: '',
            columnHeaders: [],
            validateGender: undefined,
            validateEmail: undefined,
            validatePhone: undefined,
            getDob: undefined,
            validateDate: undefined,
            validateDayOfDate: undefined,
            maxStepTraversed: 0
        };

        this.handleNextClick = this.handleNextClick.bind(this);        
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.setFileName = this.setFileName.bind(this);
        this.customClickHandler = this.customClickHandler.bind(this);
    }

    componentDidMount() {     
        this.componentWillReceiveProps(this.props);          
        this.getRoster(this.props.match.params.rosterid);
        var x = document.getElementsByClassName('step-custom-click');
        for (let i = 0; i < x.length; i++) {            
            x[i].addEventListener('click', () => { this.customClickHandler(i); });
        }       
    }

    customClickHandler( element: any ) {

        if ( this.state.maxStepTraversed >= element 
            && this.state.maxStepTraversed < (this.steps.length - 1) ) {

            if ((element === 1 || element === 0) && this.state.current !== element) {

                var answer = confirm('Please note all previous data will be cleared. Do you want to continue ?');
                if (answer) {
                    this.setState({
                        current: element,
                        maxStepTraversed: element,
                        csvRows: [],
                        csvFileDesc: '',
                        FirstNameCol: 'Select Column',
                        MiddleNameCol: 'Select Column',
                        LastNameCol: 'Select Column',
                        IDCol: 'Select Column',
                        DOBCol: 'Select Column',
                        GenderCol: 'Select Column',
                        SportCol: 'Select Column',
                        LevelCol: 'Select Column',
                        EmailCol: 'Select Column',
                        PhoneCol: 'Select Column',
                        selectedColumns: {},
                        mappedColumns: [],
                        nextStepDisabled: true,
                        isHeader: true
                    });
                } 
            } else {
                this.setState({
                    current: element
                });
            }
        }
    }

    componentWillReceiveProps(nextProps: any) {

        console.log('ProfileBulkUpload.nextProps: ', nextProps);
        this.setState({currentProfiles: nextProps.profiles});
        console.log('profilebulkupload initializing profiles..');
        this.getRoster(nextProps.match.params.rosterid);
        this.intializeProfiles(nextProps.match.params.rosterid);
    }
    
    next() {
        const current = this.state.current + 1;
        this.setState({ current });
      }
    
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    render() {     
        console.log('profileupload state: ', this.state);      
        this.steps = [{
            id: 0,
            title: 'Instructions',
            content: this.getContentOne(),
            desc: ''
          }, {
            id: 1,
            title: 'Select CSV File',
            content: this.getContentTwo(),
            desc: this.state.csvFileDesc
          }, {
            id: 2,
            title: 'Specify EyeGuide Mapping',
            content: this.getContentThree(),
            desc: ''
          },   {
            id: 3,
            title: 'Confirm & Upload',
            content: this.getContentFour(),
            desc: ''
          },   {
            id: 4,
            title: 'Feedback',
            content: this.getContentFive(),
            desc: ''
          },    ];

        return(
        <div className="ProfileBulkUpload"> 
            <Card>
                <Breadcrumb>
                    <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a href={'/profile/' + this.props.match.params.rosterid}>
            {this.state.rosterName + ' ' + strings.lsProfilesTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{strings.lsUploadTxt}</Breadcrumb.Item>
                </Breadcrumb>
                <br/>
                <h3> {strings.lsUploadTxt} </h3>
            </Card>
            <Card bordered={false} style={{ margin: '24px 16px' }} >
                <div className="contentDiv"> 
                <div style={{width: '100%'}}>
                    <Steps current={this.state.current}>                    
                        {this.steps.map(item =>                                                     
                        <Step className="step-custom-click" key={item.id} title={item.title} description={item.desc}/>)
                        }                     
                    </Steps>                    
                </div>
                </div>
                <div className="steps-content">{this.steps[this.state.current].content}</div>
            </Card>
        </div>
        );
        // }
    }

    getContentOne() {
        return(
            <UploadContentOne
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}
            />
        );
    }

    private getContentTwo() {
        return(
            <UploadContentTwo
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}
                setFileName={this.setFileName}
                isHeader={this.state.isHeader}
            />
        );
    }
    
    private getContentThree() {
        console.log('content 3 columns', this.state.mappedColumns);
        return(
            <UploadContentThree
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}
                csvRows={this.state.csvRows}
                hasHeader={this.state.isHeader}
                mappedColumns={this.state.mappedColumns}
                selectedColumns={this.state.selectedColumns}
                FirstNameCol={this.state.FirstNameCol}
                MiddleNameCol={this.state.MiddleNameCol}
                LastNameCol={this.state.LastNameCol}
                IDCol={this.state.IDCol}
                DOBCol={this.state.DOBCol}
                GenderCol={this.state.GenderCol}
                SportCol={this.state.SportCol}
                LevelCol={this.state.LevelCol}
                EmailCol={this.state.EmailCol}
                PhoneCol={this.state.PhoneCol}
                validateGender={this.validateGender}
                validateEmail={this.validateEmail}
                validatePhone={this.validatePhone}
                validateSport={this.validateSport}
                validateLevel={this.validateLevel}
                nextStepDisabled={this.state.nextStepDisabled}
            />
        );
    }

    private getContentFour() {
        console.log('getContentFour: ', this.state.columnHeaders);
        console.log('hellooo', this.state.rosterName);
        return(
            <UploadContentFour
                rosterName={this.state.rosterName}
                rosterid={this.props.match.params.rosterid}     
                currentProfiles={this.state.currentProfiles}    
                columnData={this.state.columnData}
                columnHeaders={this.state.columnHeaders}
                hasHeader={this.state.isHeader}
                csvRows={this.state.csvRows}
                loading={this.state.loading}
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}
                validateGender={this.validateGender}
                validateEmail={this.validateEmail}
                validatePhone={this.validatePhone}
                validateSport={this.validateSport}
                validateLevel={this.validateLevel}
                getDob={this.state.getDob}
                FirstNameCol={this.state.FirstNameCol}
                LastNameCol={this.state.LastNameCol}
                DOBCol={this.state.DOBCol}
                GenderCol={this.state.GenderCol}
                SportCol={this.state.SportCol}
                LevelCol={this.state.LevelCol}
                EmailCol={this.state.EmailCol}
                PhoneCol={this.state.PhoneCol}
            />
        );
    }

    private getContentFive() {
        return(
            <UploadContentFive
                updates={this.state.updateCount}        
                uploads={this.state.uploadCount}
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}  
            />
        );
    }

    /**
     * Gets the roster name from server to display in BreadCrumb
     * @param rosterid 
     */
    private async getRoster(rosterid: string) {
        if (rosterid !== '' && rosterid !== null && rosterid !== undefined) {
            let ser = new service();
            let roster = await ser.getOrganizationByRoster(rosterid);
            this.setState({rosterName: roster.name});
        } 
    }

    private validateLevel(level: string) {
        if (level === '' || Constants.getLevels().indexOf(level) > -1) {
            return level;
        }
        return INVALIDLEVEL;
    }

    private validateSport(sports: string) {
        console.log('sports', sports);
        let sportList = sports.split(',').map(sport => sport.toLowerCase());
        let allSports = Constants.getSports().map(sport => sport.toLowerCase());
        let invalid = sportList.filter(sport => allSports.indexOf(sport.trim()) === -1);
        console.log('sports', invalid);
        if (sports === '' || invalid.length === 0) {
            return sports;
        }
        return INVALIDSPROT;
    }

    private validateEmail(email: string) {
        if (email.length) {
            let isValid = Util.validateEmail(email.trim());
            return isValid ? email : INVALIDEMAILMSG;
        }
        return email;
    }

    private validatePhone(phone: string) {
        console.log('validate phone', phone);
        if (phone.length) {
            let isValid = Util.validatePhone(phone.trim());
            console.log('validate phone', phone.length);
            return isValid ? phone : INVALIDPHONEMSG;
        }
        return phone;
    }

    private handleNextClick(obj: any, contentNum: number) {
        Util.resetScroll();
        if (contentNum === 1 ) {
            console.log('1st content next clicked');
            this.setState({
                current: 1,
                maxStepTraversed: (this.state.maxStepTraversed < contentNum ? 
                    contentNum : this.state.maxStepTraversed)
            });
        } else if (contentNum === 2 ) {
            console.log('2nd content next clicked', obj);
            this.setState({
                current: 2,
                csvRows: obj.rows,
                isHeader: obj.header,
                maxStepTraversed: (this.state.maxStepTraversed < contentNum ? 
                    contentNum : this.state.maxStepTraversed)
            });
        } else if (contentNum === 3 ) {
            console.log('3rd content next clicked', obj);
            this.setState({
                current: 3,
                columnData: obj.data,
                mappedColumns: obj.mappedColumns,
                selectedColumns: obj.selectedColumns,   
                FirstNameCol: obj.FirstNameCol,
                MiddleNameCol: obj.MiddleNameCol,
                LastNameCol: obj.LastNameCol,
                IDCol: obj.IDCol,
                DOBCol: obj.DOBCol,
                GenderCol: obj.GenderCol,
                SportCol: obj.SportCol,
                LevelCol: obj.LevelCol,
                EmailCol: obj.EmailCol,
                PhoneCol: obj.PhoneCol,
                loading: obj.loading,
                nextStepDisabled: obj.nextStepDisabled,
                columnHeaders: obj.columnHeaders,
                getDob: obj.getDob,
                validateDate: obj.validateDate,
                validateDayOfDate: obj.validateDayOfDate,
                isHeader: obj.hasHeader,
                maxStepTraversed: (this.state.maxStepTraversed < contentNum ? 
                contentNum : this.state.maxStepTraversed)
            });
        } else if (contentNum === 4 ) {
            console.log('4th content next clicked', obj);
            this.setState({
                current: 4,
                updateCount: obj.updates,
                uploadCount: obj.uploads,
                maxStepTraversed: (this.state.maxStepTraversed < contentNum ? 
                    contentNum : this.state.maxStepTraversed)               
            });
        }
    }

    private handlePrevClick(contentNum: number) {
        Util.resetScroll();
        if (contentNum === 1 ) {
            console.log('1st content previous clicked');
            this.setState({
                current: 0,
                csvFileDesc: '',
                maxStepTraversed: 0,
            });
        } else if (contentNum === 2 ) {
            console.log('2nd content previous clicked');
            this.setState({
                current: 1,
                FirstNameCol: 'Select Column',
                MiddleNameCol: 'Select Column',
                LastNameCol: 'Select Column',
                IDCol: 'Select Column',
                DOBCol: 'Select Column',
                GenderCol: 'Select Column',
                SportCol: 'Select Column',
                EmailCol: 'Select Column',
                PhoneCol: 'Select Column',
                selectedColumns: {},
                mappedColumns: [],
                nextStepDisabled: true,
                maxStepTraversed: 1,
                csvFileDesc: '',
                isHeader: true
            });
        } else if (contentNum === 3 ) {
            console.log('3rd content previous clicked', this.state.mappedColumns);
            this.setState({
                current: 2,
                mappedColumns: this.state.mappedColumns
            });
        }
    }

    private setFileName(file: string) {
        this.setState({csvFileDesc: file});
    }

    /**
     * Fetches the list of profiles from server
     * @param rosterID RosterId of Sub Org selected from side menu
     */
    private async intializeProfiles(rosterID: string) {
        let ser = new service();        
        console.log('intializeProfiles', rosterID); 

        await ser.getProfiles(rosterID)
        .then( (profiles: any) => {                        
            this.setState({currentProfiles : profiles});
        });
    }

    /**
     * Validates if correct value has been given for gender in csv data
     * @param gender 
     */
    private validateGender(gender: string) {
        if (gender === undefined || gender === null) {
            return NODATAMSG;
        }
        if (gender.trim().length === 0) {
            return NODATAMSG;
        }
        let genders = Constants.getGender();
        let isValid: boolean = false;

        Object.keys(genders).forEach((key: string) => {
            if (genders[key] === gender.trim()) {
                isValid = true;
            } 
        });
        if (isValid) {
            return gender;
        }
        return INVALIDGENDERMSG;        
    }

    /**
     * Filters the list using the filter object recieved from props
     */
    /*private filterList(profiles: Array<any>) {
        console.log('filterList', profiles);
        let filterObject = this.state.filterObj;
        
        if (filterObject === null || filterObject === undefined) {
            return profiles;
        }

        return profiles.filter(function(obj: any[]) {
            let matched = false;   
            let comp: Comparator;
            comp = new Comparator();
            matched = comp.compare(filterObject, obj);
            // console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
    }*/
}


// WEBPACK FOOTER //
// ./src/components/profile/ProfileBulkUpload.tsx